import type { InboxCustomStepRowPresentation } from "../../../../../_shared/_logic/custom-step-rows"

import type { LetterDeliveryCompletionOutput } from "./completionOutput"
import type { PrintSelectionPreviewRow } from "../../../../../_shared/_logic/print-selection-preview"

const actionCaseIdFor = (row: PrintSelectionPreviewRow): string =>
  String(row.action_case_id ?? "").trim()

const completionFor = (
  row: PrintSelectionPreviewRow,
  completionsByActionCaseId: Readonly<Record<string, LetterDeliveryCompletionOutput>>,
): LetterDeliveryCompletionOutput | null => {
  const actionCaseId = actionCaseIdFor(row)
  const completion = actionCaseId ? completionsByActionCaseId[actionCaseId] : null

  if (!completion || completion.letterDeliveryBatchItemId !== row.letter_delivery_batch_item_id) {
    return null
  }

  return completion
}

export const printSelectionEnabledRows = ({
  rows,
  rowPresentations,
}: {
  rows: readonly PrintSelectionPreviewRow[]
  rowPresentations: Readonly<Record<string, InboxCustomStepRowPresentation>>
}): PrintSelectionPreviewRow[] =>
  rows.filter((row) => {
    if (!row.printable) return false

    const actionCaseId = actionCaseIdFor(row)
    const presentation = actionCaseId ? rowPresentations[actionCaseId] : null

    if (presentation?.isCompatible === false) return false

    if (presentation?.removedEarlier || presentation?.removedCurrent) return false

    return true
  })

export const selectedCompletionRows = ({
  selectedPrintRows,
  rowPresentations,
  completionsByActionCaseId,
  workflowReadOnly,
}: {
  selectedPrintRows: readonly PrintSelectionPreviewRow[]
  rowPresentations: Readonly<Record<string, InboxCustomStepRowPresentation>>
  completionsByActionCaseId: Readonly<Record<string, LetterDeliveryCompletionOutput>>
  workflowReadOnly: boolean
}): PrintSelectionPreviewRow[] => {
  if (workflowReadOnly) return []

  return selectedPrintRows.filter((row) => {
    const actionCaseId = actionCaseIdFor(row)

    if (!actionCaseId || completionFor(row, completionsByActionCaseId)) return false

    const presentation = rowPresentations[actionCaseId]

    return presentation
      ? presentation.isCompatible && presentation.isOpen && !presentation.isResolved
      : true
  })
}
